import { useState, useCallback } from 'preact/hooks';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import type { Route, Breadcrumb } from '../hooks/use-route';
import type { ComponentChildren } from 'preact';

interface ShellProps {
  route: Route;
  breadcrumbs: Breadcrumb[];
  onNavigate: (hash: string) => void;
  children: ComponentChildren;
  onOpenCommandPalette: () => void;
  tabKey?: string;
}

export function Shell({ route, breadcrumbs, onNavigate, children, onOpenCommandPalette, tabKey }: ShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  const toggleCollapse = useCallback(() => {
    setSidebarCollapsed((prev) => !prev);
  }, []);

  return (
    <>
      <Sidebar
        route={route}
        onNavigate={onNavigate}
        open={sidebarOpen}
        onClose={closeSidebar}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleCollapse}
      />
      <main class={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Topbar
          breadcrumbs={breadcrumbs}
          onNavigate={onNavigate}
          onMenuToggle={toggleSidebar}
          onOpenCommandPalette={onOpenCommandPalette}
        />
        <div class="content-area">
          {children}
        </div>
      </main>
    </>
  );
}
